// utils/UserUtils.js

const USER_KEY = "memberUser";
const TOKEN_KEY = "membersToken";

/**
 * Save user object and token to localStorage
 * @param {Object} user - Full user object from backend
 * @param {string} token - JWT token
 */
export const loginUser = (user, token) => {
  if (!user) return;
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (token) localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Remove user and token from localStorage
 */
export const logoutUser = () => {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TOKEN_KEY);
  window.location.href = "/login"; // optional redirect
};

/**
 * Check if user is logged in
 * @returns {boolean}
 */
export const isLoggedIn = () => !!localStorage.getItem(TOKEN_KEY);

/**
 * Get full user object from localStorage
 * @returns {Object|null}
 */
export const getCurrentUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

/**
 * Update current user in localStorage
 * Useful if user updates profile
 * @param {Object} updatedUser
 */
export const updateUser = (updatedUser) => {
  if (!updatedUser) return;
  localStorage.setItem(USER_KEY, JSON.stringify(updatedUser));
};

/**
 * Get JWT token
 * @returns {string|null}
 */
export const getToken = () => localStorage.getItem(TOKEN_KEY);

/**
 * Validate user property exists
 * Example: validate cohort, email, or _verified
 * @param {string} prop
 * @returns {boolean}
 */
export const validateUserProp = (prop) => {
  const user = getCurrentUser();
  return user && prop in user && !!user[prop];
};
